import Vue from 'vue'
import vueRouter from 'vue-router'


import notFound from '../components/outils/notFound.vue'
import LoginC from '../components/log/login.vue'
import Forgot from '../components/log/forgotPassword.vue'
import Recover from '../components/log/passwordRecover.vue'
import validateRegister from '../components/log/validateRegister.vue'
import activateapi from '../components/log/activationAPI.vue'
import publicaccess from '../components/log/publicAccessEntry.vue'
import moduleEditorRoutes from '../components/engine/editModule/routes'
import fieldEditorRoutes from '../components/engine/editField/routes'
import actionEditorRoutes from '../components/engine/editAction/routes'
import rightsEditorRoutes from '../components/engine/editDroits/routes'
import tabulationEditorRoutes from '../components/modules/tabulations/routes'
import guideRoutes from '../components/engine/guide/routes'
import dashboardRoutes from '../components/dashboard/routes'
Vue.use(vueRouter)

const loginPage = { path: "/login", component: LoginC, name: 'login' }
const forgotPage = { path: "/forgotpassword", component: Forgot, name: 'forgotp' }
const activationAPI = { path: "/activationAPI/:apiName", component: activateapi, name: 'activationapi' }
const notFoundPage = { path: "*", component: notFound, name: 'notfound' }
const passRecover = { path: "/passrecover", component: Recover, name: 'recover' }
const validateRegisterPage = { path: "/validateRegister", component: validateRegister, name: 'register' }

const publicAcessPages = { path: "/pa/:token", component: publicaccess, name: 'publicaccess' }

const listPagesAccess = { path: "/views/:pagename", component: publicaccess, name: 'listpublicpage' }

export const baseRoutes = [
  forgotPage,
  passRecover,
  validateRegisterPage,
  activationAPI,
  loginPage,
  publicAcessPages,
  listPagesAccess,
  ...moduleEditorRoutes,
  ...fieldEditorRoutes,
  ...actionEditorRoutes,
  ...rightsEditorRoutes,
  ...tabulationEditorRoutes,
  ...guideRoutes,
  ...dashboardRoutes,
  notFoundPage
]

const router = new vueRouter({
    mode: "history",
    routes: baseRoutes
})


export function resetRouter() {
  const newRouter = new vueRouter({
    mode: 'history',
    routes: baseRoutes   // uniquement les routes fixes
  })

  router.matcher = newRouter.matcher  // 🔥 remplace totalement les routes
}

/*
router.beforeEach((to, from, next) => {

}) */

export default router;
